module.exports = __webpack_public_path__ + "img/5.5d90ef4b.webp";